<nz-breadcrumb>
  <nz-breadcrumb-item *ngFor="let item of breadcrumbItems">
    <a *ngIf="item?.url" [routerLink]="[item.url]">{{ item.label }}</a>
    <span *ngIf="!item?.url">{{ item.label }}</span>
  </nz-breadcrumb-item>
</nz-breadcrumb>
